module.exports = __webpack_public_path__ + "static/media/4a.23e4dfc7.jpg";